var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vcr-title"},[_c('gkAdEvent',{attrs:{"tag":"a","type":"text","idea":_vm.ad}},[_vm._v(" "+_vm._s(_vm.ad.desc)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }